export const compareBuildingNumbers = (left, right) =>
  String(left.residentialNumber ?? "").localeCompare(
    String(right.residentialNumber ?? ""), "bg", { numeric: true, sensitivity: "base" },
  ) || left.id - right.id;
